import React from "react";
import {Link} from "react-router-dom";
import {Breadcrumb} from "antd";

export function HomeBreadcrumbItem() {
    return <Breadcrumb.Item separator=">">
        <Link to={`/exports`}>Home</Link>
    </Breadcrumb.Item>
}